export const privacyPolicy = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Privacy Policy',
  url: 'https://www.boldare.com/privacy-policy/',
  description:
    'Privacy Policy of Boldare. We are committed to safeguarding the privacy of our website visitors and explain how we collect, use, and protect personal data. This policy covers information collected via the website, including cookies, contact forms, newsletters, and legal obligations.',
  publisher: {
    '@type': 'Organization',
    name: 'BOLDARE S.A.',
    url: 'https://www.boldare.com',
    legalName: 'BOLDARE S.A.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Zwycięstwa 52',
      postalCode: '44-100',
      addressLocality: 'Gliwice',
      addressCountry: 'PL',
    },
    taxID: 'NIP: 6312698829',
    identifier: {
      '@type': 'PropertyValue',
      name: 'KRS',
      value: '0000914518',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'ado@boldare.com',
      contactType: 'Data Protection Officer',
    },
  },
};
